import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './survey.routes';
import addHtml from './modal/add.html';

export class SurveyController {
  $http;
  socket;
  awesomeThings = [];
  surveys = [];
  newThing = '';

  /*@ngInject*/
  constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
    this.$http = $http;
    this.socket = socket;
    this.$uibModal = $uibModal;
    this.$cookies = $cookies;
    this.$cookieStore = $cookieStore;
    this.$location = $location;


    $scope.$on('$destroy', function() {
      socket.unsyncUpdates('survey');
    });
  }

  $onInit() {

    if (this.$cookies.get('token')) {
      this.$http.get('/api/surveys/', {
        header: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'token': this.$cookies.get('token')
        }
      })
        .then(response => {
          if (response.data.data) {
            this.surveys = response.data.data;
            this.socket.syncUpdates('survey', this.surveys);
          }
        });
    } else {
      this.$location.path('main')
    }
  }

  // addThing() {
  //   if(this.newThing) {
  //     this.$http.post('/api/things', {
  //       name: this.newThing
  //     });
  //     this.newThing = '';
  //   }
  // }

  deleteSurvey(survey, index) {
    this.$http.delete(`/api/surveys/${survey._id}`).then(response => {
      if (response.status === 204) {
        this.surveys.splice(index, 1)
      }
    }, error => {
      console.log(error);
    });
  }


  addSurvey() {
    const surveys = this.surveys;
    this.$uibModal.open({
      template: addHtml,
      size: 'lg',
      /*@ngInject*/
      controller: function($scope, $http, $uibModalInstance) {
        $scope.vm = {};
        $scope.save = function(myForm) {
          if (myForm.$valid === false) {
            return false;
          } else {
            $http.post('/api/surveys', $scope.vm).then((response) => {
              console.log(response.data);
              $uibModalInstance.close(response.data, response.add);
            }, (error) => {
              console.log(error);
            });
          }
        };
        $scope.cancel = function() {
          $uibModalInstance.close();
        };
      }
    })
      .result.then(function(ret,marks) {
      if (ret && marks) {
        surveys.push(ret);
      }
      if (ret && !marks) {
        console.log(ret);
        console.log(surveys[0]);
        surveys[0].name = ret.data.name;
        surveys[0].url = ret.data.url;
      }
    }, function () {
    });
  }

}

export default angular.module('tttApp.survey', [uiRouter])
  .config(routing)
  .component('survey', {
    template: require('./survey.html'),
    controller: SurveyController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/survey.component.js